<!-- 中观总结 -->
<template>
  <div>
    <H3Title :title="'中观总结'"></H3Title>
    <div class="txt" v-if="ZGConclusion.IPORemark">
      <div class="txt-top">
        <p class="txt-top-title">市场估值</p>
        <p>1.资金供给<span class="redchild" v-html="ZGConclusion.fundingSupplyRemark"></span></p>
        <p>2.最近陆股通流入资金<span class="redchild" v-html="ZGConclusion.lgtRemark"></span></p>
        <p>3.融资余额<span class="redchild" v-html="ZGConclusion.ZGFinancingBalanceMoney"></span></p>
        <p>4.增持金额<span class="redchild" v-html="ZGConclusion.ZGIncreaseMoney"></span></p>
      </div>
      <div class="txt-bottom">
        <p class="txt-bottom-title">资金需求</p>
        <p>1.资金流动性<span class="redchild" v-html="ZGConclusion.currencyLiquidityRemark"></span></p>
        <p>2.最近IPO金额处于历史<span class="redchild" v-html="ZGConclusion.IPORemark"></span>水平</p>
        <p>3.减持金额<span class="redchild" v-html="ZGConclusion.ZGReductionMoney"></span></p>
      </div>
    </div>
  </div>
</template>

<script>
import H3Title from "@/components/H3Title";
export default {
  name: "HGConclusion",
  components: {
    H3Title
  },
  props: {
    elementId: {
      type: String,
      default: "hello"
    },
    ZGConclusion: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  data() {
    return {
      chart: {}
    };
  }
};
</script>

<!-- Add 'scoped' attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.txt {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  left: 10%;
  position: relative;
  top: 10px;
  font-size: 13px;
  p {
    line-height: 25px;
  }
  &-top {
    margin-bottom: 10px;
    &-title {
      font-size: 15px;
    }
  }
  &-bottom-title {
    font-size: 15px;
  }
}
</style>
<style>
 .redchild span {
    color: #fd4332;
  }
</style>